"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var angular = require("angular");
var input_screen_1 = require("../logic/input-screen");
var constraints_1 = require("../logic/constraints");
var issue_list_1 = require("../../../../../../components/utils/issue-list/issue-list");
var inav_utils_service_1 = require("../../../../../../components/utils/inav-utils.service");
angular.module('smartorg.r6.acts.inputScreen').directive("inputScreen", ["$timeout", "$rootScope", "$route", function ($timeout, $rootScope, $route) {
        return {
            restrict: 'E',
            template: require('../../template/input-screen.html'),
            scope: {
                smartorg: '=?',
                overrideInput: '&?',
                deoverrideInput: '&?',
                menu: '=',
                autocomplete: '@?',
                isCommonData: '@?',
                commonDataSaveCallback: '&?',
                isInav: '=?',
                isCorteva: '=?'
            },
            link: function (scope, ele) {
                function turnoffAutoComplete() {
                    if (!scope.autocomplete || scope.autocomplete === 'off') {
                        var allInputs = angular.element(ele).find("input");
                        for (var i = 0; allInputs[i]; i++) {
                            allInputs[i].setAttribute("autocomplete", "off");
                        }
                    }
                }
                $('body').on('hidden.bs.popover', function (e) {
                    $(e.target).data("bs.popover").inState = {
                        click: false,
                        hover: false,
                        focus: false
                    };
                });
                function showAlert(type, title, message) {
                    scope.$emit('workbench:alert', {
                        type: type,
                        title: title,
                        message: message
                    });
                }
                function checkAnchoredScaleImgKey(inputs) {
                    // let identifier = "TechnologyCAN";
                    // return inputs.find(function (item) {
                    //     return item.Key == identifier
                    // })
                    return false;
                }
                function isDistributionAvailable(inputs) {
                    for (var i = 0; i < inputs.length; i++) {
                        if (inputs[i]['Type'] == 'DISTRIBUTION') {
                            return true;
                        }
                    }
                    return false;
                }
                function loadSettings(portfolioName, settingsFromWorkbench) {
                    var settings = settingsFromWorkbench || {};
                    var sessionSettingString = localStorage.getItem('PortfolioConfig');
                    if (sessionSettingString) {
                        var sessionSettings = JSON.parse(sessionSettingString)[portfolioName];
                        if (sessionSettings && sessionSettings.inputScreen) {
                            settings = sessionSettings.inputScreen;
                        }
                    }
                    return {
                        showProb: settings.showInputScreenProbForm !== 'false',
                        showRange: settings.showInputScreenRangeForm !== 'false'
                    };
                }
                scope.formIsDirty = false;
                scope.inavFormIsDirty = false;
                scope.refreshTable = true;
                scope.showInputScreen = true;
                scope.modalData;
                scope.selectedIssue;
                scope.theList;
                scope.theIndex;
                scope.utilsService;
                scope.isQualitative = false;
                scope.isIssueModalUpdated = false;
                scope.issueConfig = {};
                scope.clampStikcy;
                // type InputItem = {
                //     Constraint: string | string[]; // Adjust the type as needed
                //     // Other properties as needed
                //   };
                scope.$on('command:INPUT_SCREEN', function (event, args) {
                    // const argsCopy = angular.copy(args);
                    var main = args.config.data.inputScreenConfig.main;
                    scope.actionMenuItem = args.actionMenuItem;
                    scope.nodeName = main.nodeName;
                    scope.node = args.node;
                    scope.title = scope.actionMenuItem + " for " + scope.nodeName;
                    scope.formIsDirty = false;
                    scope.inavFormIsDirty = false;
                    document.getElementById('instructions').innerHTML = main.instructions;
                    scope.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.INPUT_SCREEN);
                    var inputScreenConfig = angular.copy(args.config.data.inputScreenConfig);
                    scope.savableInputs = 'savableInputs' in inputScreenConfig.main ?
                        inputScreenConfig.main.savableInputs : [];
                    scope.inputConfig = inputScreenConfig;
                    scope.inputData = inputScreenConfig.main.inputs.filter(function (x) { return x.Type.toUpperCase() !== 'TABLE'; });
                    scope.targetDS = inputScreenConfig.main.targetDS;
                    var dataLt = {};
                    if (scope.node && 'inavImpactType' in scope.node) {
                        scope.isQualitative = scope.node['inavImpactType'] == 'Qualitative';
                    }
                    // for Inav
                    if (scope.isInav) {
                        scope.modalData = {
                            distInputs: main['colHeaders'],
                            inputTypeLt: main['radioOrCheckbox'],
                            npvData: main['npvSwing']
                        };
                        scope.issueConfig = scope.utilsService.getIssueConfig(inputScreenConfig.main.issueConfig);
                        inputScreenConfig.main.impactMappingList.forEach(function (sticky) {
                            if (sticky.impactMappingList != 'default' && sticky.impactMappingList.length > 0) {
                                sticky.impactMappingList.forEach(function (range) {
                                    dataLt[range.key] = dataLt[range.key] || [];
                                    sticky.color = scope.issueConfig[sticky.type];
                                    sticky.title = sticky.title ? sticky.title : sticky.name.substring(0, 13);
                                    sticky.isHeightUpdated = false;
                                    dataLt[range.key].push(sticky);
                                });
                            }
                        });
                        scope.issueConfig = main['issueConfig'];
                        scope.inavImpactMapping = dataLt;
                        scope.originalInavImpactMapping = angular.copy(dataLt);
                        scope.nColCanvasSwotData = inputScreenConfig.main.nColCanvasSwotData;
                    }
                    scope.options = { show: true, id: -1 };
                    scope.user = inputScreenConfig.user;
                    scope.selectedInputKey = args.config.data.selectedInputKey;
                    scope.settings = loadSettings(args.treeName, args.config.data.settings);
                    scope.isDistributionAvailable = isDistributionAvailable(args.config.data.inputScreenConfig.main.inputs);
                    scope.showAnchoredScaleImg = checkAnchoredScaleImgKey(args.config.data.inputScreenConfig.main.inputs);
                    var readOnly = args.readOnly || false;
                    if (scope.inputConfig) {
                        scope.disableEdit = readOnly || scope.inputConfig.nodeAttribute == 'r';
                    }
                    $timeout(function () {
                        var pops = $('[data-toggle="popover"]');
                        pops.popover();
                        // Hide function is in menu widget.
                    }, 200);
                    scope.test = function (e) {
                        var code = (e.keyCode ? e.keyCode : e.which);
                        console.log(e);
                    };
                    scope.toggleClamp = function (id, stickyIndex, note) {
                        scope.expandSticky = scope.expandSticky == note._id ? null : note._id;
                        scope.utilsService.setFontSize(note, id, stickyIndex);
                    };
                    scope.sliderOptionsFor = function (inputItem) {
                        if (inputItem.Anchors && inputItem.Anchors.length) {
                            var legends_1 = [];
                            var pointDescription = {};
                            for (var i = 0; i < inputItem.Anchors.length; i++) {
                                legends_1.push({
                                    value: inputItem.Anchors[i]['Legend'],
                                    legend: 'Label' in inputItem.Anchors[i] ?
                                        inputItem.Anchors[i]['Label'] : inputItem.Anchors[i]['Point'].toString(),
                                    point: inputItem.Anchors[i]['Point']
                                });
                                pointDescription[inputItem.Anchors[i]['Legend']] = inputItem.Anchors[i]['Text'];
                                if (inputItem.Val == inputItem.Anchors[i]['Point']) {
                                    inputItem.legend = inputItem.Anchors[i]['Legend'];
                                }
                            }
                            inputItem.pointDescription = pointDescription;
                            return {
                                showTicks: true,
                                ceil: inputItem.Max,
                                floor: inputItem.Min,
                                stepsArray: legends_1,
                                onChange: function (sliderID, modelValue, highValue) {
                                    for (var j = 0; j < legends_1.length; j++) {
                                        if (legends_1[j]['value'] === inputItem.legend) {
                                            inputItem.Val = legends_1[j]['point'];
                                        }
                                    }
                                    scope.checkSave();
                                },
                                disabled: inputItem.InputType === 'INHERITED' || scope.disableEdit,
                                hideLimitLabels: 'HideLimitLabels' in inputItem ? inputItem.HideLimitLabels : true
                            };
                        }
                    };
                    scope.showInputScreen = !(scope.inputConfig.sibling.templateID &&
                        scope.inputConfig.sibling.templateID != "not_specified" &&
                        scope.inputConfig.main.templateID !== scope.inputConfig.sibling.templateID);
                    if (scope.inputConfig.sibling.leafOrPlatform) {
                        if (scope.inputConfig.main.leafOrPlatform == "leaf" &&
                            scope.inputConfig.sibling.leafOrPlatform !== scope.inputConfig.main.leafOrPlatform) {
                            scope.cannotCompareMsg = "Compare Inputs are only available for the same kind of nodes. " +
                                "The selected node is a basic node, it can only be compared with another basic node.";
                        }
                        else if (scope.inputConfig.main.leafOrPlatform == "platform" &&
                            scope.inputConfig.sibling.leafOrPlatform !== scope.inputConfig.main.leafOrPlatform) {
                            scope.cannotCompareMsg = "Compare Inputs are only available for the same kind of nodes. " +
                                "The selected node is a platform node, it can only be compared with another platform node.";
                        }
                    }
                    else {
                        scope.cannotCompareMsg = undefined;
                    }
                    scope.selectedInput = {
                        'Name': 'Single Variables',
                        'Key': null
                    };
                    if (scope.inputData) {
                        if (scope.selectedInputKey == null ||
                            scope.selectedInputKey == "None") {
                            scope.selectedInput = {
                                'Name': 'Single Variables',
                                'Key': null
                            };
                        }
                        createSingleVarInputScreen();
                    }
                    scope.formIsDirty = false;
                    refreshSlider();
                    scope.menu = menu;
                    $timeout(function () {
                        turnoffAutoComplete();
                    });
                });
                scope.$on('saveInput', function (event, args) {
                    scope.selectedIssue = __assign({}, args.selectedIssue);
                    scope.isIssueModalUpdated = true;
                    scope.save();
                });
                function refreshSlider() {
                    $timeout(function () {
                        scope.$broadcast('rzSliderForceRender');
                    });
                }
                scope.$watch(function () {
                    return $(ele).children()[0].clientWidth;
                }, function (width, oldWidth) {
                    if (width !== oldWidth) {
                        scope.showMidLegend = width > 800;
                        setTimeout(function () {
                            // This line triggers the loop.
                            refreshSlider();
                            scope.refreshing = false;
                        }, 50);
                    }
                }, true);
                scope.$on('workbench:toggle-collapse:right', function () {
                    setTimeout(function () {
                        refreshSlider();
                    });
                });
                scope.$on('workbench:toggle-collapse:left', function () {
                    setTimeout(function () {
                        refreshSlider();
                    });
                });
                scope.formatIntl = function (args, event, index) {
                    // scope.unformatValue(args, index);
                    if (Array.isArray(args.Val)) {
                        if (!isNaN(+event.target.value)) {
                            args.Val[index] = +event.target.value;
                            scope.formatValue(args, index);
                        }
                    }
                    else {
                        args.Val = event.target.value;
                        if (args.Constraint != 'string' && args.Constraint != 'text' && !isNaN(args.Val)) {
                            args.Val = +args.Val;
                            scope.formatValue(args);
                        }
                    }
                    $timeout(function () {
                        scope.checkSave();
                    });
                };
                // const isDistribution = Array.isArray(args.Val);
                // let val = isDistribution ? args.Val[index] : args.Val;
                // Old version
                // scope.formatValue = function(args, index) { //{locale,range,options,Val, formattedValue} [100,33,32], 0 -> [100$, 33$, 32$]
                //     console.log(index);
                //     let locale = args.Locale ?? 'en-US';
                //     let range = args.Range ?? 1;
                //     // Only apply formatting when options available from data structure
                //     if(args.Options){
                //         //Preset
                //         args.Options.minimumFractionDigits = args.Options.minimumFractionDigits ?? 2;
                //         args.Options.maximumFractionDigits = args.Options.maximumFractionDigits ?? 2;
                //         args.FormattedValue[index] = parseFloat(args.Val[index].toString().replace(/[^0-9.-]/g, '')) || 0;
                //         // % case
                //         if(args.Options.style == "percent" && args.FormattedValue[index] >= 1){
                //             args.Val[index] = args.FormattedValue[index] = args.FormattedValue[index] / 100;
                //         }
                //         // Apply formatting
                //         args.FormattedValue[index] = new Intl.NumberFormat(locale, args.Options).format(args.FormattedValue[index]);
                //     }else{
                //         args.FormattedValue[index] = args.Val[index];
                //     }
                // }
                // new version
                scope.formatValue = function (args, index) {
                    var _a = args.Locale, Locale = _a === void 0 ? 'en-US' : _a, _b = args.Range, Range = _b === void 0 ? 1 : _b, Options = args.Options;
                    console.log("VAL");
                    console.log(args.Val);
                    var isDistribution = Array.isArray(args.Val);
                    // if((isDistribution && (!args.isFormatted || !args.isFormatted[index])) || (!isDistribution && !args.isFormatted)){
                    if (Options) {
                        // Set defaults directly in the options object
                        // old
                        // Options.minimumFractionDigits = Options.minimumFractionDigits || 2;
                        // Options.maximumFractionDigits = Options.maximumFractionDigits || 2;
                        Options.minimumFractionDigits =
                            (Options.minimumFractionDigits !== undefined && Options.minimumFractionDigits !== null)
                                ? Options.minimumFractionDigits
                                : 2;
                        Options.maximumFractionDigits =
                            (Options.maximumFractionDigits !== undefined && Options.maximumFractionDigits !== null)
                                ? Options.maximumFractionDigits
                                : 2;
                        // Ensure max is greater than or equal to min
                        if (Options.maximumFractionDigits < Options.minimumFractionDigits) {
                            Options.maximumFractionDigits = Options.minimumFractionDigits;
                        }
                        var formattedValue = parseFloat((isDistribution ? args.Val[index] : args.Val).toString().replace(/[^0-9.-]/g, '')) || 0;
                        // % case 
                        if (Options.style === "percent" && formattedValue > 1 &&
                            ((isDistribution && (!args.isFormatted || !args.isFormatted[index])) || (!isDistribution && !args.isFormatted))) {
                            // if value not already formatted otherwise format multiple times in case of 100% and above
                            if (isDistribution) {
                                args.isFormatted = args.isFormatted || [];
                                formattedValue = args.Val[index] = !args.isFormatted[index] ? (formattedValue / 100) : formattedValue;
                            }
                            else {
                                formattedValue = args.Val = !args.isFormatted ? (formattedValue / 100) : formattedValue;
                            }
                        }
                        // Apply formatting
                        var res = new Intl.NumberFormat(Locale, Options).format(formattedValue);
                        isDistribution ? (args.FormattedValue[index] = res) : (args.FormattedValue = res);
                    }
                    else {
                        isDistribution ? (args.FormattedValue[index] = args.Val[index]) : (args.FormattedValue = args.Val);
                    }
                    if (isDistribution) {
                        args.isFormatted = args.isFormatted || [];
                        args.isFormatted[index] = true;
                    }
                    else {
                        args.isFormatted = true;
                    }
                    // }
                };
                scope.unformatValue = function (args, index) {
                    // Only apply unformatting when options available
                    // if(args.Options){
                    //     args.Val[index] = args.Val[index].toString().replace(/[^0-9.-]/g, '');
                    //     // Remove trailing zeros after the decimal point
                    //     args.Val[index] = args.Val[index].toString().replace(/\.?0*$/, '');
                    //     // % case
                    //     if(args.Options.style == "percent" && args.Val[index] < 1){
                    //         args.Val[index] = (args.Val[index] / 100);
                    //     }
                    // }
                    var isDistribution = Array.isArray(args.Val);
                    isDistribution ? (args.FormattedValue[index] = args.Val[index]) : (args.FormattedValue = args.Val);
                };
                scope.validate = function (evt, args, index) {
                    var key = evt.key;
                    var newValue;
                    if (key === '-' && evt.target.value === '') {
                        evt.preventDefault();
                        evt.target.value = key;
                        evt.target.dispatchEvent(new Event('input', { bubbles: true }));
                        return;
                    }
                    // Special handling for when field contains "0" - replace with whatever is typed
                    if (evt.target.value === '0' && key != ".") {
                        // Prevent the default keypress behavior
                        evt.preventDefault();
                        // Set the field value directly to the new key
                        newValue = evt.target.value = key;
                        // Trigger change event to update the model
                        evt.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                    // Special handling for minus sign - place at beginning if cursor is at start or text is selected
                    else if (key === '-') {
                        var cursorPosition = evt.target.selectionStart;
                        var selectionEnd = evt.target.selectionEnd;
                        var hasSelection = cursorPosition !== selectionEnd;
                        if (cursorPosition === 0 || hasSelection) {
                            // Cursor is at the beginning or text is selected, place minus at start
                            evt.preventDefault();
                            newValue = evt.target.value = '-';
                            // Update the model value
                            if (Array.isArray(args.Val)) {
                                args.Val[index] = '-';
                            }
                            else {
                                args.Val = '-';
                            }
                            // Trigger change event to update the model
                            evt.target.dispatchEvent(new Event('input', { bubbles: true }));
                        }
                        else {
                            // Cursor is not at beginning, use normal logic
                            newValue = evt.target.value + key;
                        }
                    }
                    // Special handling for decimal point when text is selected
                    else if (key === '.') {
                        var cursorPosition = evt.target.selectionStart;
                        var selectionEnd = evt.target.selectionEnd;
                        var hasSelection = cursorPosition !== selectionEnd;
                        if (hasSelection) {
                            // Text is selected, use default behavior (replace with ".")
                            evt.preventDefault();
                            newValue = evt.target.value = '.';
                            // Update the model value
                            if (Array.isArray(args.Val)) {
                                args.Val[index] = '.';
                            }
                            else {
                                args.Val = '.';
                            }
                            // Trigger change event to update the model
                            evt.target.dispatchEvent(new Event('input', { bubbles: true }));
                            return;
                        }
                        else {
                            // No selection, use normal logic
                            newValue = evt.target.value + key;
                        }
                    }
                    else {
                        newValue = evt.target.value + key;
                    }
                    //  Allow navigation keys to pass
                    if (key == "ArrowLeft" ||
                        key == "ArrowRight" ||
                        key == "Tab" ||
                        key == "ArrowUp" ||
                        key == "ArrowDown" ||
                        key == "Backspace" ||
                        key == "End" ||
                        key == "PageUp" ||
                        key == "PageDown" ||
                        key == "Home" ||
                        args.Constraint == 'string' ||
                        args.Constraint == 'text') {
                        return;
                    }
                    // If a modifier key is held down then don't perform the check
                    if (!evt.ctrlKey && !evt.metaKey && !evt.altKey) {
                        // const filter = /^(\d*)(\.\d*)?$/g; // Allow only numbers from 0 to 9 and up to one decimal point
                        var filter = /^(-?\d*)(-?\.\d*)?$/g; // Allow only numbers from 0 to 9 and up to one decimal point and up to one minus sign
                        if (newValue.match(filter)) {
                            // Reset formatting when value changed
                            var isDistribution = Array.isArray(args.Val);
                            isDistribution ? (args.isFormatted[index] = false) : (args.isFormatted = false);
                            // if(!args.isFormatted[index]){
                            //     // if %
                            //     args.Val[index] = args.Val[index] / 100;
                            // }
                            return;
                        }
                        evt.preventDefault();
                    }
                };
                function createSingleVarInputScreen() {
                    scope.inputScreenData = new input_screen_1["default"](scope.inputData, scope.inputConfig.sibling.inputs, scope.inputConfig.main.invisibleInputs, scope.inputConfig.sibling.invisibleInputs, scope.settings);
                    scope.origInputScreenData = angular.copy(scope.inputScreenData);
                    scope.data = scope.inputScreenData.inputData;
                    //HERE HERE    
                    // Bind slider options
                    bindSliderOptions();
                    scope.placement = scope.inputScreenData.placement;
                    scope.commentFormType = scope.inputScreenData.commentFormTypes;
                    scope.currentComments = angular.copy(scope.inputScreenData.currentComments);
                    scope.universalTableComments = angular.copy(scope.inputScreenData.universalTableComments);
                    scope.currentCommentStr = scope.inputScreenData.createCurrentCommentStr(scope.currentComments);
                    scope.origCurrentCommentStr = angular.copy(scope.currentCommentStr);
                    scope.timelineVisible = scope.inputScreenData.timelineVisible;
                    scope.origData = angular.copy(scope.inputScreenData.origInputData);
                    scope.nodeID = scope.inputConfig.main.nodeID;
                    scope.formatInitData(scope.data);
                    scope.formatInitData(scope.origData);
                }
                scope.formatInitData = function (data) {
                    data.forEach(function (input) {
                        input.FormattedValue = [];
                        console.log(input.Type);
                        // if(!Array.isArray(input.Val)){
                        //     input.Val = [input.Val];
                        // }
                        if (input.Type == 'DISTRIBUTION') {
                            input.Val.forEach(function (el, index) {
                                input.FormattedValue[index] = 0;
                                if (input.Val[index] > 1 && input.Options && input.Options.style === "percent") {
                                    input.Val[index] = el * 100;
                                }
                                console.log(input.Val[index]);
                                scope.formatValue(input, index);
                                console.log(input.FormattedValue[index]);
                            });
                        }
                        else {
                            scope.formatValue(input);
                            console.log(input.FormattedValue);
                        }
                        // else if(input.Type != 'DATE'){
                        //     scope.formatValue(input); 
                        //     console.log(input.FormattedValue); 
                        // }
                        console.log(input.Val);
                    });
                };
                function bindSliderOptions() {
                    if (scope.data) {
                        for (var i = 0; i < scope.data.length; i++) {
                            scope.data[i].sliderOptions = scope.sliderOptionsFor(scope.data[i]);
                        }
                    }
                }
                var handleDateTypeLastVal = function (lastVal) {
                    if (typeof (lastVal) === "object" && lastVal.month) {
                        lastVal = lastVal.month + " " + lastVal.year;
                    }
                    return lastVal;
                };
                scope.showHistoryModal = function (item, index) {
                    scope.currentIndex = index ? index : 0;
                    if (item.Comment) {
                        var historyComments = item.Comment.slice(0).reverse();
                        var commentMsgs = [];
                        for (var i = 0; i < historyComments.length; i++) {
                            historyComments[i].SavedOn = decodeURIComponent(historyComments[i].SavedOn);
                            commentMsgs.push(historyComments[i].msg);
                            historyComments[i].lastVal = handleDateTypeLastVal(historyComments[i].lastVal);
                        }
                        var current = { 'lastVal': handleDateTypeLastVal(scope.origData[index].Val) };
                        historyComments.unshift(current); //adding current to first position
                        scope.commentModalData = scope.inputScreenData.addDecodedMsgToCommentModalData(historyComments, commentMsgs);
                        scope.commentItem = item;
                        setTimeout(function () {
                            scope.$apply();
                        }, 0);
                    }
                };
                scope.handleSeeMore = function (index) {
                    scope.commentModalData[index].seeMore = !scope.commentModalData[index].seeMore;
                };
                scope.setTopColHeight = function (index) {
                    var el = document.getElementById('inputScreenLabel:' + index);
                    var target = document.getElementById('threeValueRow:' + index);
                    if (el && target) {
                        var height = el.scrollHeight - 10;
                        target.style.height = height + "px";
                    }
                };
                scope.formatIssueData = function (item) {
                    item.description = 'description' in item ? item.description : "";
                    var impactToBeUsed = scope.isQualitative ? item.impact : item.calcImpact;
                    item.title = item.title ? item.title : item.name.substring(0, 13);
                    // item.impact = impactToBeUsed;
                    item.score = item.ignorance * impactToBeUsed;
                    item.issueType = scope.utilsService.getDiscoveryGrid(item.ignorance, impactToBeUsed);
                    item.issueColor = scope.utilsService.zoneColor[item.issueType.replace(/ /g, "")];
                    if (item.experimentData.length > 0) {
                        item.experimentData = item.experimentData[0];
                    }
                    else {
                        item.experimentData.defined = 0;
                    }
                    var isDfv = false;
                    var isSwot = false;
                    if (item.type == scope.utilsService.issueType.DESIRABILITY.NAME ||
                        item.type == scope.utilsService.issueType.FEASIBILITY.NAME ||
                        item.type == scope.utilsService.issueType.VIABILITY.NAME) {
                        item.isDfv = true;
                    }
                    else if (item.type == scope.utilsService.issueType.STRENGTHS.NAME ||
                        item.type == scope.utilsService.issueType.WEAKNESSES.NAME ||
                        item.type == scope.utilsService.issueType.OPPORTUNITIES.NAME ||
                        item.type == scope.utilsService.issueType.THREATS.NAME) {
                        item.isSwot = true;
                    }
                    item.isDfv = isDfv;
                    item.isSwot = isSwot;
                    return item;
                };
                scope.onEditSticky = function (issueId, list) {
                    for (var i = 0; i < list.length; i++) {
                        if (issueId == list[i]._id) {
                            scope.selectedIssue = angular.copy(scope.formatIssueData(list[i]));
                            $timeout(function () {
                                scope.$emit('issueModal', { 'modalData': scope.modalData, 'selectedIssue': scope.selectedIssue,
                                    'node': scope.node, 'issueList': issue_list_1.IssueListEnum.INPUT_SCREEN });
                                scope.$apply();
                            }, 1000);
                            break;
                        }
                    }
                };
                scope.setStickyHeight = function (id, node) {
                    var ctrl = this;
                    var element = document.getElementById(id);
                    if (!node[id] && element.scrollHeight > 0) {
                        ctrl.setFontSize(id);
                        node[id] = true; // id + index to uniquely identify that is it height updated or not
                    }
                };
                scope.setFontSize = function (id) {
                    // 100, 90, 38
                    var element = document.getElementById(id);
                    if (element != null) {
                        var elHeight = element.scrollHeight;
                        if (elHeight <= 45) {
                            elHeight = 45;
                        }
                        element.style.height = "1px";
                        element.style.height = (elHeight + 3) + "px"; // 3 px for padding so 3px for adjustments
                        var inputNote = element.parentElement.parentElement.parentElement;
                        inputNote.style.height = "1px";
                        inputNote.style.height = (55 + elHeight) + "px";
                        var targetParentBlock = inputNote.parentElement;
                        if (targetParentBlock.classList.contains("block") || targetParentBlock.classList.contains("centered-sticky")) {
                            targetParentBlock.style.height = "1px";
                            targetParentBlock.style.height = (55 + elHeight) + "px";
                        }
                        // Update height of reason for low/high textarea according to stikcy height
                        var reasonForLow = document.getElementById(id + 'low').parentElement;
                        var reasonForHigh = document.getElementById(id + 'high').parentElement;
                        // Margin calculation to center the Div
                        reasonForLow.style.height = reasonForLow.style.lineHeight =
                            reasonForHigh.style.height = reasonForHigh.style.lineHeight = inputNote.style.height;
                    }
                };
                scope.setHoveredSticky = function (show, id) {
                    scope.options = { show: true, id: id };
                };
                scope.showIcons = function (id) {
                    return scope.options.show == true && scope.options.id == id;
                };
                // only Inav
                scope.reasonChange = function (distInput) {
                    if (scope.isInav) {
                        scope.checkSaveImpactMapping();
                    }
                };
                scope.getReasonModel = function (sticky, inputKey) {
                    var item = { "low": "", "high": "" };
                    sticky.impactMappingList.forEach(function (range) {
                        if (range.key == inputKey) {
                            item = range.reason;
                        }
                    });
                    return item;
                };
                function makeImpactMappingList(impactMappingData) {
                    var distKeys = Object.keys(impactMappingData);
                    var impactMappingList = [];
                    for (var i = 0; i < distKeys.length; i++) {
                        impactMappingList = impactMappingList.concat(impactMappingData[distKeys[i]]);
                    }
                    return impactMappingList;
                }
                // only Inav
                scope.checkSaveImpactMapping = function () {
                    scope.inavFormIsDirty = false;
                    scope.validInput = true;
                    var origImpactMappingList = makeImpactMappingList(scope.originalInavImpactMapping);
                    var impactMappingList = makeImpactMappingList(scope.inavImpactMapping);
                    for (var i = 0; i < impactMappingList.length; i++) {
                        for (var j = 0; j < origImpactMappingList.length; j++) {
                            if (impactMappingList[i]['_id'] == origImpactMappingList[j]['_id']) {
                                for (var x = 0; x < impactMappingList[i]['impactMappingList'].length; x++) {
                                    for (var y = 0; y < origImpactMappingList[j]['impactMappingList'].length; y++) {
                                        if (impactMappingList[i]['impactMappingList'][x]['key'] == origImpactMappingList[j]['impactMappingList'][y]['key']) {
                                            if (impactMappingList[i]['impactMappingList'][x]['reason']['low'] != origImpactMappingList[j]['impactMappingList'][y]['reason']['low']) {
                                                scope.inavFormIsDirty = true;
                                                break;
                                            }
                                            if (impactMappingList[i]['impactMappingList'][x]['reason']['high'] != origImpactMappingList[j]['impactMappingList'][y]['reason']['high']) {
                                                scope.inavFormIsDirty = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    setGlobalDirty();
                };
                scope.showCommentBox = function (index) {
                    scope.currentIndex = index ? index : 0;
                    scope.currentInstruction = scope.inputData[index].Instruction;
                    angular.element("#editCommentModal").modal({
                        backdrop: 'static', show: true
                    });
                };
                scope.checkSave = function () {
                    scope.inputScreenData.currentComments = angular.copy(scope.currentComments);
                    scope.currentCommentStr = scope.inputScreenData.createCurrentCommentStr(scope.currentComments);
                    if (!scope.formscope) {
                        scope.formscope = this;
                    }
                    scope.formIsDirty = scope.inputScreenData &&
                        scope.inputScreenData.isDirty();
                    if (!scope.formIsDirty && scope.formscope.form) {
                        scope.formscope.form.$setPristine();
                    }
                    if (!scope.formIsDirty) {
                        scope.resetFormFromDirty();
                    }
                    if (scope.data) {
                        scope.validInput = isInputDataValid(scope.data);
                    }
                    if (scope.validInput) {
                        scope.inputScreenData.evaluate();
                    }
                    setGlobalDirty();
                };
                function setGlobalDirty() {
                    $timeout(function () {
                        $rootScope.smartorgDirty = scope.formIsDirty || scope.inavFormIsDirty;
                    }, 0);
                }
                function isInputDataValid(data) {
                    var result = true;
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var inputItem = data_1[_i];
                        var itemValid = true;
                        if (inputItem.Constraint instanceof Array) {
                            for (var _a = 0, _b = inputItem.Constraint; _a < _b.length; _a++) {
                                var constraint = _b[_a];
                                itemValid = validateConstraint(inputItem, constraint);
                                if (!itemValid) {
                                    break; // Exit the inner loop
                                }
                            }
                        }
                        else if (inputItem.Constraint) {
                            itemValid = validateConstraint(inputItem, inputItem.Constraint);
                        }
                        if (!itemValid) {
                            result = false;
                            break; // Exit the outer loop
                        }
                    }
                    return result;
                }
                function validateConstraint(inputItem, constraint) {
                    var result = true;
                    if (inputItem.Val === undefined || inputItem.Val === null) {
                        result = false;
                    }
                    else {
                        var validation = new constraints_1["default"](constraint);
                        if (inputItem.Type === 'DISTRIBUTION') {
                            for (var _i = 0, _a = inputItem.Val; _i < _a.length; _i++) {
                                var v = _a[_i];
                                // For MaxMin Constraint
                                if (inputItem.Max || inputItem.Min) {
                                    inputItem.Value = v;
                                    result = validation.isValidFor(inputItem);
                                }
                                else {
                                    result = validation.isValidFor(v);
                                }
                                if (!result) {
                                    // break loop in case of invalid value
                                    break;
                                }
                            }
                        }
                        else {
                            if ((inputItem.Max || inputItem.Min) && inputItem.Type !== 'TABLESCALE') {
                                inputItem.Value = inputItem.Val;
                                if (inputItem.Type == 'ANCHOREDSCALE') {
                                    result = validation.isValidFor(inputItem.Value);
                                }
                                else {
                                    result = validation.isValidFor(inputItem);
                                }
                            }
                            else {
                                result = validation.isValidFor(inputItem.Val);
                            }
                        }
                    }
                    return result;
                }
                function isOrderedReset() {
                    scope.data.forEach(function (inputItem) {
                        inputItem.isOrdered = true;
                    });
                }
                function resetOriginals() {
                    scope.saving = false;
                    scope.inputScreenData.copyToOrig();
                    scope.formIsDirty = false;
                    scope.origData = angular.copy(scope.inputScreenData.origInputData);
                    scope.universalTableComments = angular.copy(scope.inputScreenData.universalTableComments);
                    scope.currentCommentStr = scope.inputScreenData.createCurrentCommentStr(scope.currentComments);
                    scope.origCurrentCommentStr = angular.copy(scope.currentCommentStr);
                    setGlobalDirty();
                    $timeout(function () {
                        scope.checkSave();
                    });
                }
                // only Inav
                function saveInavImpactMappingAndInputs() {
                    var impactMappingList = makeImpactMappingList(scope.inavImpactMapping);
                    for (var i = 0; i < impactMappingList.length; i++) {
                        var dfvSwotType = impactMappingList[i]['type'];
                        for (var j = 0; j < scope.nColCanvasSwotData[dfvSwotType].length; j++) {
                            if (scope.nColCanvasSwotData[dfvSwotType][j]['_id'] == impactMappingList[i]['_id']) {
                                scope.nColCanvasSwotData[dfvSwotType][j]['impactMappingList'] = impactMappingList[i]['impactMappingList'];
                                scope.nColCanvasSwotData[dfvSwotType][j]['updatedAt'] = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
                            }
                        }
                    }
                    // Update issue from issueModal data
                    if (scope.selectedIssue) {
                        var selectedIndex = void 0;
                        var issueType = void 0;
                        for (var type in scope.nColCanvasSwotData) {
                            selectedIndex = scope.nColCanvasSwotData[type].findIndex(function (x) { return x._id == scope.selectedIssue._id; });
                            if (selectedIndex > -1) {
                                issueType = type;
                                break;
                            }
                        }
                        // update values
                        for (var key in scope.nColCanvasSwotData[issueType][selectedIndex]) {
                            scope.nColCanvasSwotData[issueType][selectedIndex][key] = scope.selectedIssue[key];
                        }
                        scope.selectedIssue = null;
                    }
                    scope.smartorg.saveImpactMappingData(scope.inputConfig.main.nodeID, scope.nColCanvasSwotData).then(function (res) {
                        if (res) {
                            scope.originalInavImpactMapping = angular.copy(scope.inavImpactMapping);
                            scope.inavFormIsDirty = false;
                            if (scope.formIsDirty) {
                                saveInputs();
                            }
                            else {
                                resetOriginals();
                                // reload when update Issue view modal
                                if (scope.isIssueModalUpdated) {
                                    scope.$emit('workbench:back', { reload: true });
                                }
                                showAlert('success', "Saved!", '');
                            }
                        }
                        else {
                            showAlert('danger', "Error!", 'Could not save.');
                        }
                    })["catch"](function (err) {
                        showAlert('danger', "Error!", err.message);
                        scope.saving = false;
                    });
                }
                function saveInputs() {
                    // implement dropdown tags -> update tag value on node
                    var inputData = scope.inputScreenData.generateSaveData(scope.user);
                    scope.refreshTable = false;
                    // Trim the comments of inputs for sending to api.
                    for (var i = 0; i < inputData.length; i++) {
                        var lastComment = inputData[i].Comment[inputData[i].Comment.length - 1];
                        inputData[i].Comment = [lastComment];
                    }
                    var inputDataToSave = angular.copy(inputData);
                    var isDropdownTagsChanged = scope.inputScreenData.isDropdownTagsChanged();
                    var isValueChanged = scope.inputScreenData.isInputDataValueChanged();
                    if (scope.savableInputs) {
                        for (var i = 0; i < scope.savableInputs.length; i++) {
                            for (var j = 0; j < inputData.length; j++) {
                                if (scope.savableInputs[i]['SaveIf'] == inputData[j]['Key']) {
                                    scope.savableInputs[i]['ReferenceVal'] = inputData[j]['Val'];
                                    inputDataToSave.push(scope.savableInputs[i]);
                                }
                            }
                        }
                    }
                    var allowSave = true;
                    inputDataToSave.forEach(function (input) {
                        if ('Val' in input && input['Val'].constructor == Array) {
                            scope.data.forEach(function (inputItem) {
                                if (inputItem['Key'] == input['Key']) {
                                    var constraint = new constraints_1["default"](inputItem.Constraint);
                                    inputItem.isOrdered = constraint.isOrdered(inputItem.Val);
                                    if (allowSave) {
                                        allowSave = inputItem.isOrdered != false;
                                    }
                                }
                            });
                        }
                    });
                    if (allowSave) {
                        scope.smartorg.saveInputs(scope.inputConfig.main.nodeID, inputDataToSave).then(function (ret) {
                            if (ret && ret.msg && ret.msg.toUpperCase().startsWith('ERROR')) {
                                showAlert('danger', "Error!", ret.msg);
                            }
                            resetOriginals();
                            scope.resetFormFromDirty();
                            showAlert('success', "Saved!", '');
                            scope.refreshTable = true;
                            if (scope.commonDataSaveCallback) {
                                scope.commonDataSaveCallback();
                            }
                            scope.$emit('workbench:last_updated', { nodeID: scope.inputConfig.main.nodeID });
                            if (isValueChanged) {
                                if (!scope.isCommonData) {
                                    scope.$emit('workbench:update_isDataValid', { nodeIdList: [scope.inputConfig.main.nodeID] });
                                }
                                else {
                                    scope.$emit('workbench:update_isDataValid', {
                                        nodeIdList: [scope.inputConfig.main.nodeID],
                                        isDataValid: false
                                    });
                                }
                            }
                            if (isDropdownTagsChanged) {
                                scope.$emit('workbench:back', { reload: true });
                                // do for each tag
                                // if(scope.filterQuery){
                                var nodeId = scope.inputConfig.main.nodeID;
                                var encodedDropdownTags_1 = [];
                                var dropdownTags = scope.inputConfig.main.inputs.filter(function (tag) { return (tag.Type === 'DROPDOWN' || tag.Type === 'DATABASE_DROPDOWN'); });
                                dropdownTags.forEach(function (tag) {
                                    encodedDropdownTags_1.push(scope.encodeDropdownTag(tag));
                                    console.log(encodedDropdownTags_1);
                                });
                                console.log(scope.inputConfig.main);
                                // Extract dropdown tags from inputConfig
                                // let dropdownTags = scope.inputConfig.main.dropdownTags;
                                scope.$emit('workbench:update_dropdown_tags', {
                                    'nodeID': nodeId,
                                    'dropdownTags': encodedDropdownTags_1
                                });
                                // scope.$emit('workbench:reloadTreeAndApplyFilter', {
                                //     filterQuery: scope.filterQuery
                                // });
                                // }
                            }
                            isOrderedReset();
                        })["catch"](function (err) {
                            showAlert('danger', "Error!", err.message);
                            scope.saving = false;
                            $timeout(function () {
                                scope.checkSave();
                            });
                        });
                    }
                    else {
                        scope.saving = false;
                        showAlert('danger', 'Error!', 'Could not save inputs.');
                    }
                }
                scope.encodeDropdownTag = function (tag) {
                    var Key = tag.Key, Val = tag.Val, Display = tag.Display;
                    return Key + ":" + encodeURIComponent(btoa(Val)) + ":" + encodeURIComponent(btoa(Display));
                };
                scope.save = function () {
                    scope.saving = true;
                    if (!scope.inavFormIsDirty && scope.formIsDirty) {
                        saveInputs();
                    }
                    else {
                        saveInavImpactMappingAndInputs();
                    }
                };
                scope.resetFormFromDirty = function () {
                    var form = document.getElementById("inputscreenForm");
                    var formScope = angular.element(form).scope();
                    // Now you can access form properties and methods
                    if (formScope.form) {
                        // Access form properties or methods
                        console.log(formScope.form.$valid);
                        formScope.form.$setPristine();
                    }
                };
                scope.reset = function () {
                    scope.formIsDirty = false;
                    scope.data = angular.copy(scope.origData);
                    scope.inputScreenData.currentComments = angular.copy(scope.inputScreenData.origCurrentComments);
                    scope.currentCommentStr = angular.copy(scope.origCurrentCommentStr);
                    bindSliderOptions();
                    scope.inputScreenData.inputData = scope.data;
                    for (var i = 0; i < scope.currentComments.length; i++) {
                        if (scope.commentFormType[i])
                            scope.currentComments[i].form = angular.copy(scope.inputScreenData.currentComments[i].form);
                        else
                            scope.currentComments[i].val = angular.copy(scope.inputScreenData.currentComments[i].val);
                    }
                    scope.inavFormIsDirty = false;
                    scope.inavImpactMapping = angular.copy(scope.originalInavImpactMapping);
                    scope.resetFormFromDirty();
                    isOrderedReset();
                    setGlobalDirty();
                    $timeout();
                };
                // not found usage anywhere
                scope.toggleTimeline = function (index) {
                    scope.inputScreenData.toggleTimeLineAt(index);
                };
                // scope
                scope.override = function (inputItem) {
                    scope.overrideInput({
                        targetNodeId: scope.inputConfig.main.nodeID,
                        sourceNodeId: inputItem.rootID,
                        inputKey: inputItem.Key
                    });
                    inputItem.InputType = 'OVERRIDE';
                };
                function getDeoverrideDiscardChangeMessage(inputItem) {
                    var discardChangeMessage = "De-Override will erase all the input data of " + inputItem.Display + ". ";
                    if ('DependentKeys' in inputItem) {
                        var tableNames = inputItem.DependentKeys.map(function (key) {
                            return ("Table Variable " + scope.inputConfig.main.inputs.find(function (i) { return i.Key === key; }).Display);
                        });
                        discardChangeMessage += tableNames.join(", ") + " might also be affected. ";
                    }
                    discardChangeMessage += "\nDo you want to proceed?";
                    return discardChangeMessage;
                }
                // scope
                scope.deOverride = function (inputItem) {
                    if (!confirm(getDeoverrideDiscardChangeMessage(inputItem))) {
                        return;
                    }
                    scope.deoverrideInput({
                        targetNodeId: scope.inputConfig.main.nodeID,
                        inputKey: inputItem.Key
                    });
                    inputItem.InputType = 'INHERITED';
                };
                var menu = [{
                        'name': 'Save',
                        'class': 'btn btn-xs btn-danger',
                        'show': function () {
                            return (scope.formIsDirty || scope.inavFormIsDirty) && !scope.saving && scope.validInput;
                        },
                        'callback': function () {
                            scope.save();
                        }
                    }, {
                        'name': 'Reset',
                        'class': 'btn btn-xs btn-primary',
                        'show': function () {
                            return (scope.formIsDirty || scope.inavFormIsDirty) && !scope.saving;
                        },
                        'callback': function () {
                            scope.reset();
                        }
                    }, {
                        'name': '',
                        'class': 'btn btn-xs btn-danger',
                        'icon': 'fa fa-spinner fa-spin fa-fw',
                        'show': function () {
                            return scope.saving;
                        }
                    }];
            }
        };
    }]).filter('historyReplaceQuotes', function () {
    return function (item) {
        return typeof item !== 'undefined' ? item.toString().replace(/["\[\]]/g, '') : "";
    };
}).filter('parseAsNumber', function () {
    return function (input) {
        // Check if input is a string
        if (typeof input === 'string') {
            // Remove any non-numeric characters and parse as a float
            return parseFloat(input.replace(/[^\d.-]/g, '')) || 0;
        }
        // If input is not a string, return it as is
        return input;
    };
});
//# sourceMappingURL=input-screen-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/app/js/plumbing/input-screen-directive.js